import { render, staticRenderFns } from "./crmBranchsDetail.vue?vue&type=template&id=8bf958a6&scoped=true"
import script from "./crmBranchsDetail.vue?vue&type=script&lang=js"
export * from "./crmBranchsDetail.vue?vue&type=script&lang=js"
import style0 from "./crmBranchsDetail.vue?vue&type=style&index=0&id=8bf958a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf958a6",
  null
  
)

export default component.exports